// Review #2, D4.3: Terms and Privacy Policy must open in a new tab. In-app they were
// <Link>s, so on checkout and signup they navigated away and discarded everything typed.
//
// The app runs on HashRouter, so the route lives in the fragment. Building the href from
// origin + pathname keeps it absolute — a bare "#/terms" resolves against whatever the
// current URL happens to be, which is fragile once a page has its own query string.
const LegalLink = ({ to, className = '', children }) => {
  const base =
    typeof window === 'undefined' ? '' : `${window.location.origin}${window.location.pathname}`

  return (
    <a href={`${base}#${to}`} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
    </a>
  )
}

export default LegalLink
